import { OperationAccess } from 'constants/operationAccesses';

import { usePermissions } from 'hooks/usePermissions';
import { BooleanInputStyled } from 'pages/Gateways/components/GatewaysForm.styled';
import { Box } from 'shared/mui/Box';
import { Stack } from 'shared/mui/Stack/Stack';

type Props = {
  onPcidssChange?: () => void;
};

export const GatewaysCreateBooleanFields: React.FC<Props> = ({ onPcidssChange }) => {
  const { hasOperationAccess } = usePermissions();

  return (
    <Stack direction="row" gap={3}>
      {hasOperationAccess(OperationAccess.ManageMerchantAccounts) && (
        <Box>
          <BooleanInputStyled
            defaultValue={false}
            label="Проверен менеджером"
            size="small"
            source="managerVerified"
          />
        </Box>
      )}
      <BooleanInputStyled label="PCI DSS" onChange={onPcidssChange} size="small" source="pcidss" />
      <BooleanInputStyled label="Push API" size="small" source="pushApi" />
      <BooleanInputStyled label="Требуется сумма" size="small" source="requireAmount" />
      <BooleanInputStyled
        label="Сохранить данные метода"
        size="small"
        source="saveCustomerMethodData"
      />
    </Stack>
  );
};
